const angular = require('angular');

const OrderInstructionsService = require('./order-instructions.service');

angular.module('wowApp.shop')
    .service('OrderInstructionsService', OrderInstructionsService);



// WEBPACK FOOTER //
// ./src/order/orderinstructions/index.js